module.exports = __webpack_public_path__ + "media/images/common/side_cart_bg_top-9b400a13ba5fc6a4d5f43b123b1cefb5.gif";